import axios from "axios";
import Swal from "sweetalert2";
import i18n from "../../i18n";

export default {
  get _layoutHelpers () {
    return window.layoutHelpers
  },

  _exec (fn) {
    return this._layoutHelpers && fn()
  },

  getLayoutSidenav () {
    return this._exec(() => this._layoutHelpers.getLayoutSidenav()) || null
  },

  getSidenav () {
    return this._exec(() => this._layoutHelpers.getSidenav()) || null
  },

  getLayoutNavbar () {
    return this._exec(() => this._layoutHelpers.getLayoutNavbar()) || null
  },

  getLayoutFooter () {
    return this._exec(() => this._layoutHelpers.getLayoutFooter()) || null
  },

  getLayoutContainer () {
    return this._exec(() => this._layoutHelpers.getLayoutContainer()) || null
  },

  isSmallScreen () {
    return this._exec(() => this._layoutHelpers.isSmallScreen())
  },

  isLayout1 () {
    return this._exec(() => this._layoutHelpers.isLayout1())
  },

  isCollapsed () {
    return this._exec(() => this._layoutHelpers.isCollapsed())
  },

  isFixed () {
    return this._exec(() => this._layoutHelpers.isFixed())
  },

  isOffcanvas () {
    return this._exec(() => this._layoutHelpers.isOffcanvas())
  },

  isNavbarFixed () {
    return this._exec(() => this._layoutHelpers.isNavbarFixed())
  },

  isFooterFixed () {
    return this._exec(() => this._layoutHelpers.isFooterFixed())
  },

  isReversed () {
    return this._exec(() => this._layoutHelpers.isReversed())
  },

  setCollapsed (collapsed, animate = true) {
    this._exec(() => this._layoutHelpers.setCollapsed(collapsed, animate))
  },

  toggleCollapsed (animate = true) {
    this._exec(() => this._layoutHelpers.toggleCollapsed(animate))
  },

  setPosition (fixed, offcanvas) {
    this._exec(() => this._layoutHelpers.setPosition(fixed, offcanvas))
  },

  setNavbarFixed (fixed) {
    this._exec(() => this._layoutHelpers.setNavbarFixed(fixed))
  },

  setFooterFixed (fixed) {
    this._exec(() => this._layoutHelpers.setFooterFixed(fixed))
  },

  setReversed (reversed) {
    this._exec(() => this._layoutHelpers.setReversed(reversed))
  },

  update () {
    this._exec(() => this._layoutHelpers.update())
  },

  setAutoUpdate (enable) {
    this._exec(() => this._layoutHelpers.setAutoUpdate(enable))
  },

  on (event, callback) {
    this._exec(() => this._layoutHelpers.on(event, callback))
  },

  off (event) {
    this._exec(() => this._layoutHelpers.off(event))
  },

  init () {
    this._exec(() => this._layoutHelpers.init())
  },

  destroy () {
    this._exec(() => this._layoutHelpers.destroy())
  },

  hasRole(roles) {
    if (!roles) return true;
    let userRoles = JSON.parse(localStorage.getItem('mentechCustomerDetails')).roles;

    if (!Array.isArray(roles)) return userRoles.indexOf(roles) !== -1;

    for (let i=0; i<roles.length; i++) {
      if (userRoles.indexOf(roles[i]) !== -1) {
        return true
      }
    }

    return false;
  },

  isGuest() {
    let user = this.getUser();
    return user?.guest === true;
  },

  getUser() {
    let user = JSON.parse(localStorage.getItem('mentechCustomerDetails'));

    return user;
  },

  setUser(user) {
    return new Promise(function(resolve, reject) {
      localStorage.setItem('mentechCustomerDetails', JSON.stringify(user));
      resolve(user);
    })
  },

  getFirstName() {
    let user = JSON.parse(localStorage.getItem('mentechCustomerDetails')).fullName;

    return user.split(" ")[0];
  },

  getMonthName(month) {
    return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][month];
  },

  getCurrency() {
    return JSON.parse(localStorage.getItem('mentechCustomerDetails')).currency
  },

  canEditDevice(device) {
    if (this.getUser().id === device.userId) {
      return true;
    }

    if (this.hasRole('ROLE_CUSTOMER_SUPER_ADMIN_USER')) {
      return true;
    }

    return false;
  },

  getDefaultConnectTo(t) {
    return new Promise(function(resolve, reject) {
      let ref = new URL(window.location.href).searchParams.get('ref');
      let user = t.getUser();

      // Denmark has closed, so Mentech connects those visitors to Norway instead.
      if (!window.location.hostname.includes("refurbee") && window.location.hostname != "localhost") {
        if (ref && ref.toUpperCase() === "DK") {
          ref = "NO";
        }

        if (localStorage.getItem('connectToRef') === "DK") {
          localStorage.setItem('connectToRef', "NO");
        }

        if (user && user.connectTo === "DK") {
          localStorage.removeItem('mentechCustomerDetails');
          user = null;
        }
      }

      if (window.location.hostname == "localhost") {
        resolve("DEV");
      } else if (user) {
        resolve(user.connectTo);
      } else {
        if (!localStorage.getItem('connectToRef') || (ref && (ref.toUpperCase() != localStorage.getItem('connectToRef')))) {
          let choices = "";
          let languages = "";
          let html = "";

          languages += "<option value='no'>Norwegian</option>";
          languages += "<option value='se'" + (ref && ref.toUpperCase() === "SE" ? " selected" : "") + ">Swedish</option>";
          languages += "<option value='en'>English</option>";
          languages += "<option value='fi'>Finnish</option>";

          html = "<div class='form-group text-left'><label>Language</label><select id='swal-input1' class='form-control'>"+languages+"</select></div>";

          if (!ref) {
            JSON.parse(process.env.REACT_APP_API_LIST)[0][t.getHost()].map(item => (
                choices += "<option key="+item.code+" value="+item.code+">"+t.getSystem() + " " + item.country+"</option>"
            ))

            html += "<div class='form-group text-left'><label>Service location</label><select id='swal-input2' class='form-control'>"+choices+"</select></div>";
          }

          Swal.fire({
            title: "Select language",
            description: "",
            allowOutsideClick: false,
            allowEscapeKey: false,
            html: html,
            preConfirm: () => {
              return {
                language: document.getElementById('swal-input1').value,
                connectTo: ref ? null : document.getElementById('swal-input2').value
              }
            }
          }).then((result) => {
            i18n.changeLanguage(result.value.language);
            localStorage.setItem('connectToRef', ref ? ref.toUpperCase() : result.value.connectTo);
            window.location.reload();
            resolve( ref ? ref.toUpperCase() : result.value.connectTo)
          });
        } else {
          resolve(localStorage.getItem('connectToRef'))
        }
      }
    });
  },

  getAPI() {
    let t = this;
    return new Promise(function(resolve, reject) {
      t.getDefaultConnectTo(t).then((connectTo) => {
        let host = window.location.hostname.includes("refurbee") ? "refurbee" : "mentech";
        let list = JSON.parse(process.env.REACT_APP_API_LIST)[0][host];

        for (var i = 0; i < list.length; i++) {
          if (list[i].code === connectTo) {
            resolve(list[i].api);
          }
        }

        resolve(process.env.REACT_APP_API_URL_DA[0][host]);
      })
    })
  },

  // Sweden is closing, so it only finishes repairs that already exist.
  acceptsNewRepairs() {
    let t = this;
    return new Promise(function(resolve, reject) {
      t.getDefaultConnectTo(t).then((connectTo) => {
        resolve(connectTo !== "SE");
      })
    })
  },

  getDigitalServiceAPI() {
    let t = this;
    return new Promise(function(resolve, reject) {
      t.getDefaultConnectTo(t).then((connectTo) => {
        if (connectTo == "DK") {
          resolve("cab5554ed9552b774b4b2cb42d4f4172")
        } else if (connectTo == "NO") {
          resolve("85b290407b40b88b3ebf02dda5636919")
        } else {
          resolve("cab5554ed9552b774b4b2cb42d4f4172");
        }
      })
    })
  },

  getStripeAPI() {
    let t = this;
    return new Promise(function(resolve, reject) {
      t.getDefaultConnectTo(t).then((connectTo) => {
        if (connectTo == "DK") {
          resolve("pk_live_51M0N2kLqAUbrNjYBq8ENXMG5tRVwn7mToQLUFd6rXdcaSbpqyIXfYD4K8x5RuJYEA1OzhzPbgYJSrSH20xeUR8bJ003oVydLgw")
        } else if (connectTo == "NO") {
          resolve("pk_live_GlshWLZUyGoRVZTmcb6A4qG4")
        } else if(connectTo == "SE") {
          resolve("pk_live_51MTmqMGdUclBWJnFmRmevZuxl53Xdc97yz3xCMze1Ge8T2OglykEBnRHybUeI65QzJCxpdOvupZHc9xA9Mx2Zsng007AAcao4i");
        } else {
          resolve("pk_live_51M0N2kLqAUbrNjYBq8ENXMG5tRVwn7mToQLUFd6rXdcaSbpqyIXfYD4K8x5RuJYEA1OzhzPbgYJSrSH20xeUR8bJ003oVydLgw");
        }
      })
    })
  },

  getApiByCountry(country) {
    console.log(country);
    if (window.location.hostname === "localhost") {
      country = "DEV";
    }

    let host = window.location.hostname.includes("refurbee") ? "refurbee" : "mentech";
    let list = JSON.parse(process.env.REACT_APP_API_LIST)[0][host];
    for (var i = 0; i < list.length; i++) {
      if (list[i].code === country) {
        return (list[i].api);
      }
    }

    return JSON.parse(process.env.REACT_APP_API_URL_DA)[host];
  },

  getLogo() {
    let host = window.location.hostname.includes("refurbee") ? "refurbee" : "mentech";
    return process.env.PUBLIC_URL + '/img/'+JSON.parse(process.env.REACT_APP_LOGO)[host];
  },


  getPictureURL() {
    let v = new Date().getTime();
    return "https://api.mentech.no/nsp/get/product/image?v="+v+"&url=";
  },

  getSystem() {
    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }

    let host = window.location.hostname.includes("refurbee") ? "Refurbee" : "Mentech";
    link.href = process.env.PUBLIC_URL + (host == "Refurbee" ? '/favicon-refurbee.png' : "/favicon.png");

    return host;
  },

  isValidCountry(country) {
    let list = JSON.parse(process.env.REACT_APP_API_LIST);
    for(var i = 0; i < list.length; i++) {
      if(list[i].code === country) {
        return true
      }
    }
    return false;
  },

  getHost() {
    return window.location.hostname.includes("refurbee") ? "refurbee" : "mentech";
  },

  getTermsAndConditionsLink() {
    let t = this;
    return new Promise(function(resolve, reject) {
      t.getDefaultConnectTo(t).then((api) => {
        let obj = {
          "refurbee": {
            "DK": "https://refurbee.dk/handelsbetingelser/",
            "SE": "https://refurbee.se/kopvillkor/",
          },
          "mentech": {
            "DEV": "https://mentech.dk/page/betingelser.html",
            "DK": "https://mentech.dk/kontakt/betingelser/",
            "SE": "https://mentech.se/kontakt/kopvillkor/",
            "NO": "https://mentech.no/kontakt/handelsvilkar/"
          }
        }

        resolve(obj[t.getHost()][api]);
      });
    })
  },

  convertCountryCodeToPhoneCode(country) {
    let list = {"BD": "880", "BE": "32", "BF": "226", "BG": "359", "BA": "387", "BB": "+1-246", "WF": "681", "BL": "590", "BM": "+1-441", "BN": "673", "BO": "591", "BH": "973", "BI": "257", "BJ": "229", "BT": "975", "JM": "+1-876", "BV": "", "BW": "267", "WS": "685", "BQ": "599", "BR": "55", "BS": "+1-242", "JE": "+44-1534", "BY": "375", "BZ": "501", "RU": "7", "RW": "250", "RS": "381", "TL": "670", "RE": "262", "TM": "993", "TJ": "992", "RO": "40", "TK": "690", "GW": "245", "GU": "+1-671", "GT": "502", "GS": "", "GR": "30", "GQ": "240", "GP": "590", "JP": "81", "GY": "592", "GG": "+44-1481", "GF": "594", "GE": "995", "GD": "+1-473", "GB": "44", "GA": "241", "SV": "503", "GN": "224", "GM": "220", "GL": "299", "GI": "350", "GH": "233", "OM": "968", "TN": "216", "JO": "962", "HR": "385", "HT": "509", "HU": "36", "HK": "852", "HN": "504", "HM": " ", "VE": "58", "PR": "+1-787 and 1-939", "PS": "970", "PW": "680", "PT": "351", "SJ": "47", "PY": "595", "IQ": "964", "PA": "507", "PF": "689", "PG": "675", "PE": "51", "PK": "92", "PH": "63", "PN": "870", "PL": "48", "PM": "508", "ZM": "260", "EH": "212", "EE": "372", "EG": "20", "ZA": "27", "EC": "593", "IT": "39", "VN": "84", "SB": "677", "ET": "251", "SO": "252", "ZW": "263", "SA": "966", "ES": "34", "ER": "291", "ME": "382", "MD": "373", "MG": "261", "MF": "590", "MA": "212", "MC": "377", "UZ": "998", "MM": "95", "ML": "223", "MO": "853", "MN": "976", "MH": "692", "MK": "389", "MU": "230", "MT": "356", "MW": "265", "MV": "960", "MQ": "596", "MP": "+1-670", "MS": "+1-664", "MR": "222", "IM": "+44-1624", "UG": "256", "TZ": "255", "MY": "60", "MX": "52", "IL": "972", "FR": "33", "IO": "246", "SH": "290", "FI": "358", "FJ": "679", "FK": "500", "FM": "691", "FO": "298", "NI": "505", "NL": "31", "NO": "47", "NA": "264", "VU": "678", "NC": "687", "NE": "227", "NF": "672", "NG": "234", "NZ": "64", "NP": "977", "NR": "674", "NU": "683", "CK": "682", "XK": "", "CI": "225", "CH": "41", "CO": "57", "CN": "86", "CM": "237", "CL": "56", "CC": "61", "CA": "1", "CG": "242", "CF": "236", "CD": "243", "CZ": "420", "CY": "357", "CX": "61", "CR": "506", "CW": "599", "CV": "238", "CU": "53", "SZ": "268", "SY": "963", "SX": "599", "KG": "996", "KE": "254", "SS": "211", "SR": "597", "KI": "686", "KH": "855", "KN": "+1-869", "KM": "269", "ST": "239", "SK": "421", "KR": "82", "SI": "386", "KP": "850", "KW": "965", "SN": "221", "SM": "378", "SL": "232", "SC": "248", "KZ": "7", "KY": "+1-345", "SG": "65", "SE": "46", "SD": "249", "DO": "+1-809 and 1-829", "DM": "+1-767", "DJ": "253", "DK": "45", "VG": "+1-284", "DE": "49", "YE": "967", "DZ": "213", "US": "1", "UY": "598", "YT": "262", "UM": "1", "LB": "961", "LC": "+1-758", "LA": "856", "TV": "688", "TW": "886", "TT": "+1-868", "TR": "90", "LK": "94", "LI": "423", "LV": "371", "TO": "676", "LT": "370", "LU": "352", "LR": "231", "LS": "266", "TH": "66", "TF": "", "TG": "228", "TD": "235", "TC": "+1-649", "LY": "218", "VA": "379", "VC": "+1-784", "AE": "971", "AD": "376", "AG": "+1-268", "AF": "93", "AI": "+1-264", "VI": "+1-340", "IS": "354", "IR": "98", "AM": "374", "AL": "355", "AO": "244", "AQ": "", "AS": "+1-684", "AR": "54", "AU": "61", "AT": "43", "AW": "297", "IN": "91", "AX": "+358-18", "AZ": "994", "IE": "353", "ID": "62", "UA": "380", "QA": "974", "MZ": "258"};
    return "+"+list[country];
  },

  // Internal
  //

  _removeClass (cls) {
    this._exec(() => this._layoutHelpers._removeClass(cls))
  },

  parseError(error)
  {
    if (!error.response.data || !error.response.data.includes("Swal.fire")) {
      return "";
    }

    return error.response.data.split(',')[1].replace("'", "").replace("'", "");
  }

}
